<template>
  <div class="text-center not-available-tag">
    <div>NOT AVAILABLE</div>
    <div>
      Until Further Notice
    </div>
  </div>
</template>

<script>
    export default {
        name: "deactiveFood"
    }
</script>

<style scoped>

</style>
